import { useParams } from 'react-router-dom';

import useHashmapConverter from 'hooks/useHashmapConverter';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useQueryActivityCodesByVersion } from 'api/queries/activityCodesByVersion.query';
import { useQueryClustersList } from 'api/queries/clustersList.query';
import { useQueryGetTaskDataByHashCode } from 'api/queries/getTaskDataByHashCode.query';
import { useQueryGetSingleWbs } from 'api/queries/getWbs.query';

import { ProgramStatusUrlParams } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramStatusSummaryReport/programStatusSummaryReportTypes';
import { Props } from 'components/widgets/RiskRegister/components/SegmentCell/SegmentCell.provider.types';

export const useSegmentCellProvider = ({ activitiesByKey }: Props) => {
    const hashcode = Object.values(useParams<ProgramStatusUrlParams>()).filter(Boolean).join(',');
    const { versionList: versionFromHashMap, idList } = useHashmapConverter(hashcode);
    const latestVersionId = versionFromHashMap[0]?.versionDbId;
    const { project } = useProjectTreeStore();

    return {
        api: {
            getSpecificActivities: useQueryGetTaskDataByHashCode({
                metaDataId: latestVersionId,
                hashCodesList: activitiesByKey?.specific ?? undefined,
            }),
            getWbs: useQueryGetSingleWbs({
                latestVersion: latestVersionId,
                taskId: activitiesByKey?.wbs ? String(activitiesByKey.wbs) : null,
            }),
            getActivityCodes: useQueryActivityCodesByVersion({ latestVersion: latestVersionId }),
            getCluster: useQueryClustersList({ idList, projectId: project?.id, compare: 'ITSELF' }),
        },
    };
};
